"use client";

import React, { FC, Fragment } from "react";
import useBreadcrumbLinks, {
	BreadcrumbLink,
	BreadcrumbProps,
} from "@/hooks/useBreadcrumbLinks";
import Link from "@/components/UI/Link/Link";
import styles from "./Breadcrumbs.module.scss";
import { BreadcrumbMarkup } from "@/components/Common/SchemaMarkup";

interface customBreadcrumbProps extends BreadcrumbProps {
	tagBreadCrumbs?: any;
}

const Breadcrumbs: FC<customBreadcrumbProps> = (props) => {
	const { paths, separator } = useBreadcrumbLinks(props);

	// For news article tags as they are not a direct breadcrumb
	const { tagBreadCrumbs } = props;

	if (!paths || paths.length === 0) {
		return null;
	}

	return (
		<nav className={styles.nav}>
			<ul>
				{paths.map((breadcrumb: BreadcrumbLink, index: number) => {
					const isLast = index === paths.length - 1;
					if (breadcrumb.text.toLocaleLowerCase() === "informational") return;

					return (
						<Fragment key={`${breadcrumb.text}-${index}`}>
							{index > 0 && <li className={styles.separator}>{separator}</li>}
							{breadcrumb.href && !isLast && (
								<li className='link'>
									<Link href={`${breadcrumb.href}`}>{breadcrumb.text}</Link>
								</li>
							)}
							{!tagBreadCrumbs && isLast && (
								<li className='link'>
									<Link href={`${breadcrumb.href}`}>{breadcrumb.text}</Link>
								</li>
							)}
							{tagBreadCrumbs !== undefined && (
								<>
									{breadcrumb.href && isLast && (
										<li className='link'>
											<Link href={`${breadcrumb.href}`}>{breadcrumb.text}</Link>
										</li>
									)}
									{index > 0 && (
										<li className={styles.separator}>{separator}</li>
									)}
									{breadcrumb.href && isLast && (
										<li className='link'>
											{Array.isArray(tagBreadCrumbs)
												? tagBreadCrumbs
												: tagBreadCrumbs.toString()}
										</li>
									)}
								</>
							)}
						</Fragment>
					);
				})}
			</ul>
			<BreadcrumbMarkup breadcrumbs={paths} />
		</nav>
	);
};

export default Breadcrumbs;
